import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { FlexyFormLabel, FlexyTextField } from '@europrocurement/flexy-components/components/atoms';
import { PrescripteurApi } from '@europrocurement/l2d-domain';

export type UserStructureMainDetailsFormProps = {
    prescriber?: PrescripteurApi;
};

/**
 * Formulaire des informations principales de la structure (SIREN, SIRET, raison sociale, TVA)
 */
export const UserStructureMainDetailsForm: React.FunctionComponent<UserStructureMainDetailsFormProps> =
    function ({ prescriber }) {
        return (
            <Box
                p={2}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                }}
            >
                <Typography
                    variant="h3"
                    paddingBottom="10px"
                >
                    Informations générales
                </Typography>

                <Box sx={{ gap: '4px', display: 'grid' }}>
                    <FlexyFormLabel required>
                        <Typography
                            variant="l2dbodys"
                            fontWeight={500}
                        >
                            SIREN
                        </Typography>
                    </FlexyFormLabel>
                    <FlexyTextField
                        type="text"
                        variant="outlined"
                        fullWidth
                        value={prescriber?.siren}
                        placeholder="123 456 789"
                        disabled
                    />
                </Box>

                <Box sx={{ gap: '4px', display: 'grid' }}>
                    <FlexyFormLabel>
                        <Typography
                            variant="l2dbodys"
                            fontWeight={500}
                        >
                            SIRET
                        </Typography>
                    </FlexyFormLabel>
                    <FlexyTextField
                        type="text"
                        variant="outlined"
                        fullWidth
                        value={prescriber?.siret}
                        placeholder="12345678901234"
                        disabled
                    />
                </Box>

                <Box sx={{ gap: '4px', display: 'grid' }}>
                    <FlexyFormLabel required>
                        <Typography
                            variant="l2dbodys"
                            fontWeight={500}
                        >
                            Raison sociale
                        </Typography>
                    </FlexyFormLabel>
                    <FlexyTextField
                        type="text"
                        variant="outlined"
                        fullWidth
                        value={prescriber?.raisonSociale}
                        placeholder="LEGAL2DIGITAL SAS"
                        disabled
                    />
                </Box>

                <Box sx={{ gap: '4px', display: 'grid' }}>
                    <FlexyFormLabel>
                        <Typography
                            variant="l2dbodys"
                            fontWeight={500}
                        >
                            TVA intracommunautaire
                        </Typography>
                    </FlexyFormLabel>
                    <FlexyTextField
                        type="text"
                        variant="outlined"
                        fullWidth
                        value={prescriber?.tvaIntracommunautaire}
                        placeholder="FR12345678901"
                        disabled
                    />
                </Box>
            </Box>
        );
    };
